// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"104":"a7638d54","125":"4cf65408"}[chunkId] + ".chunk.css";
};